/*
 * @Author: sail web admin
 * @Date: 2020-05-07 10:18:45
 * @Last Modified by: yin
 * @Last Modified time: 2024-02-04 11:47:16
 * 登录模块英文
 */
export default {
  Login: 'Log in',
  AdministratorLogin: 'Administrator login',
  MobileNumber: ' phone number',
  password: 'password',
  SMSVerificationCode: ' the code',
  GetCode: 'Get code',
  Resend: 's to resend'
};
